@import "@/scss/use-bootstrap-mixins.scss";

span.header_text {
  color: $primaryOnBackground !important;
  margin: 0 !important;
  font-size: calc(1.3rem + 0.6vw);
  font-weight: 600 !important;
}

.products_container {
  display: flex;
  flex-direction: column;
  gap: 6px;

  @include media-breakpoint-up(lg) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 12px;
  }

  .product_item {
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    padding: 6px;
    background-color: #fff;
    flex-basis: 50%;

    display: flex;
    gap: 12px;

    @include media-breakpoint-up(lg) {
      flex-basis: calc(50% - 6px);
      padding: 10px;
    }

    &.active {
      border-color: $primary !important;
    }

    .image {
      width: 60px;
      height: 60px;

      @include media-breakpoint-up(md) {
        width: 120px;
        height: 120px;
      }

      img {
        margin: 0 auto;
        width: 60px;
        height: 60px;
        object-fit: contain;

        @include media-breakpoint-up(md) {
          width: 120px;
          height: 120px;
        }
      }
    }

    .detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;

      .name {
        font-size: 14px;
        font-weight: 700 !important;
        display: block;

        @include media-breakpoint-up(md) {
          font-size: 18px;
        }
      }

      .pricing {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .amount {
          font-size: 14px !important;
          font-weight: 600 !important;
        }

        .discounted {
          font-weight: 600 !important;
          color: rgb(49, 159, 49) !important;
        }

        .qtySelector {
          display: flex;
          font-size: 14px;

          @include media-breakpoint-up(md) {
            font-size: 16px;
          }

          button {
            padding: 2px 6px;

            @include media-breakpoint-up(md) {
              padding: 2px 10px;
            }

            &:first-of-type {
              border-radius: 8px 0 0 8px;
              border-right: 0;
              border-top: 1px solid #c0c0c0;
              border-left: 1px solid #c0c0c0;
              border-bottom: 1px solid #c0c0c0;
            }

            &:last-of-type {
              border-radius: 0 8px 8px 0;
              border-left: 0;
              border-top: 1px solid #c0c0c0;
              border-right: 1px solid #c0c0c0;
              border-bottom: 1px solid #c0c0c0;
            }
          }

          span {
            padding: 1px 0;
            min-width: 40px;
            display: block;
            text-align: center !important;
            border: 1px solid #c0c0c0;

            @include media-breakpoint-up(md) {
              padding: 4px 0;
            }
          }
        }

        .outOfStock {
          font-style: italic;
          font-size: 12px;

          @include media-breakpoint-up(md) {
            font-size: 14px;
          }
        }
      }
    }
  }
}

.button_container {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  @include media-breakpoint-up(lg) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0;

    div {
      flex-basis: calc(50% - 4px);
    }

    button {
      max-width: 205px;
      align-self: flex-end;
    }
  }

  .coupon_error {
    color: red !important;
    font-size: 12px !important;
  }

  .merch_coupon {
    display: flex;

    input.coupon_input {
      font-size: 12px;
      padding: 13px 15px;
      border-radius: 4px 0 0 4px;
      border: 1px solid #d0d0d0;
      height: 41px !important;
      flex: 1;

      @include media-breakpoint-up(md) {
        font-size: 15px;
      }

      &:focus,
      &:active {
        outline: none !important;
        box-shadow: none !important;
      }
    }

    button.coupon_button {
      font-size: 14px;
      padding: 0 15px;
      border-radius: 0 4px 4px 0;
      border: 1px solid #d0d0d0;
      border-left: none;
      height: 41px !important;
      background-color: #d9d9d9;
    }
  }
}

.pickup_container {
  margin-top: 12px;

  .header_text {
    display: block;
  }

  .pickupLocations {
    div {
      display: flex;
      align-items: center;
      gap: 6px;
      .custom_checkbox {
        position: relative;
        width: 21px;
        height: 21px;

        label {
          background-color: #fff;
          width: 21px;
          height: 21px;
          border-radius: 11px;
          cursor: pointer;
          position: absolute;
          border: 1px solid #ccc;

          &:after {
            display: initial !important;
            border: 2px solid #fff;
            border-top: none;
            border-right: none;
            content: "";
            height: 6px;
            left: 4px;
            opacity: 0;
            position: absolute;
            top: 6px;
            transform: rotate(-45deg);
            width: 11px;
          }
        }

        input[type="checkbox"] {
          display: none;

          &:checked + label {
            background-color: $primaryOnBackground;
            border-color: $primaryOnBackground;

            &:after {
              opacity: 1;
            }
          }
        }
      }

      label {
      }
    }
  }
}
